'use client';

import { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-svh [&_input]:bg-white [&_input]:border-[#fef0ff]">
      {/* Left: Branding panel */}
      <div className="hidden lg:flex lg:w-2/5 bg-primary flex-col items-center justify-center">
        <img src="/images/kinetic-logo-full.svg" alt="Kinetic" className="h-20 brightness-0 invert opacity-80" />
      </div>

      {/* Right: Content */}
      <div className="w-full lg:flex-1 flex items-center justify-center bg-[#fef0ff] p-6 md:p-10">
        <div className="w-full max-w-sm">
          {children}
        </div>
      </div>
    </div>
  );
}
